import apiClient from './_axios';

export interface Rate {
   _id: string;
   store: string;
   storeName: string;
   price: number;
   title: string;
   description: string;
   availableCount: number;
}

export const listRates = async (storeId?: string) => {
   const params = storeId ? { store: storeId } : {};
   const response = await apiClient.get<{ result: Rate[] }>('/rate', { params });
   return response.data.result;
};

export const updateRate = async (
   id: string,
   payload: { title?: string; description?: string }
) => {
   const response = await apiClient.put(`/rate/${id}`, payload);
   return response.data;
};

export const deleteRate = async (id: string) => {
   const response = await apiClient.delete(`/rate/${id}`);
   return response.data;
};
